<template>
  <b-row v-loading="true" id="loading"></b-row>
</template>
<script>
import Vue from 'vue';
import { Loading } from 'element-ui';

Vue.use(Loading.directive);
export default {};
</script>
<style>
#loading {
  min-height: 200px;
  display: flex;
  align-items: center;
}

.el-loading-spinner .path {
    stroke:   #81175a !important;
}

.el-loading-mask {
    background-color: #ffffffe0 !important;
    border-radius: 0.375rem;
}
</style>
